import { render, staticRenderFns } from "./Receta.vue?vue&type=template&id=4286dda6&scoped=true"
import script from "./Receta.vue?vue&type=script&lang=js"
export * from "./Receta.vue?vue&type=script&lang=js"
import style0 from "./Receta.vue?vue&type=style&index=0&id=4286dda6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286dda6",
  null
  
)

export default component.exports